import React, { PropTypes } from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import pluralize from 'pluralize';

export default class Confirmation extends React.Component {
  state = {
    open: false,
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleConfirm = () => {
    this.setState({ open: false });
    this.props.handleConfirm();
  }

  render() {
    const actions = [
      <FlatButton
        label="Cancel"
        primary
        onTouchTap={this.handleClose}
      />,
      <FlatButton
        label="Confirm"
        secondary
        onTouchTap={this.handleConfirm}
      />,
    ];

    return (
      <Dialog
        actions={actions}
        modal={false}
        open={this.state.open}
        onRequestClose={this.handleClose}
      >
        You are about to send a message to {this.props.howMany} {pluralize('partner', this.props.howMany)}?
      </Dialog>
    );
  }
}

Confirmation.propTypes = {
  handleConfirm: PropTypes.func,
  howMany: PropTypes.number,
};

Confirmation.defaultProps = {
  handleConfirm: () => { console.log('confirmed'); },
  howMany: 0,
};



// WEBPACK FOOTER //
// ./src/app/components/massmessaging/confirmation.jsx